<script setup lang="ts">
import { Portal } from 'portal-vue'
import GwFloat, { type FloatPlacement } from '@/components/lib/GwFloat/GwFloat.vue'
import GwTransition from '@/components/lib/GwTransition/GwTransition.vue'

export interface TooltipProps {
  icon?: string
  placement?: FloatPlacement
  tooltip?: string
  variant?: '' | 'primary' | 'primary-v2' | 'error' | 'transparent'
  closeOnContentHover?: boolean
  disabled?: boolean
  closeOnClick?: boolean
}

withDefaults(defineProps<TooltipProps>(), {
  icon: 'mdi-help-circle-outline',
  placement: 'right',
  closeOnClick: true,
})
</script>
<template>
  <GwFloat
    :closeOnContentHover
    :disabled
    :placement
    :closeOnClick
    trigger="hover"
  >
    <template #opener="{ listeners, methods }">
      <slot
        name="opener"
        :listeners
        :methods
      >
        <div
          class="mdi"
          style="width: min-content"
          :class="icon"
          v-on="listeners"
        ></div>
      </slot>
    </template>
    <template #default="{ attrs, listeners, openId }">
      <portal to="main_before">
        <GwTransition
          appear
          variant="fade"
        >
          <div
            v-if="openId"
            v-bind="attrs"
            data-gwtooltip-noclose="true"
            class="gwtooltip_content"
            data-tooltip="gw-tooltip"
            :class="variant && `gwtooltip_content_variant_${variant}`"
            v-on="listeners"
          >
            <slot name="tooltip">
              <span v-html="tooltip"> </span>
            </slot>
          </div>
        </GwTransition>
      </portal>
    </template>
  </GwFloat>
</template>

<style scoped lang="scss">
.gwtooltip_content {
  position: fixed;
  z-index: 99;
  letter-spacing: normal !important;
  text-transform: none;
  border-radius: 4px;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.4;
  width: fit-content;
  padding: 0.25rem 0.75rem;
  // border: 2px solid red;
  border: 2px solid transparent;
  color: var(--clr-white-0);

  --gwtooltip-bc: var(--clr-black-3);
  &_variant {
    &_primary {
      --gwtooltip-bc: var(--clr-primary);
    }
    &_primary-v2 {
      --gwtooltip-bc: var(--app-clr-primary-v2);
      color: var(--clr-black-0);
    }
    &_error {
      --gwtooltip-bc: var(--clr-error);
    }
    &_transparent {
      --gwtooltip-bc: transparent;
      color: var(--clr-white-0);
    }
  }
  &:before {
    box-shadow: 0px 0px 3px rgb(32, 32, 32);
    content: '';
    position: absolute;
    left: 0px;
    height: 100%;
    width: 100%;
    top: 0px;
    background-color: var(--gwtooltip-bc);
    z-index: -1;
    border-radius: 4px;
  }
}
</style>
